import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const EnquireModal = ({ show, onClose, onSubmit }) => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    website: '',
    message: '',
  });

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validate = () => {
    let tempErrors = {};
    if (!formData.name) {
      tempErrors.name = 'Your name is required.';
    }
    if (!formData.email) {
      tempErrors.email = 'Email address is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = 'Email address is not valid.';
    }
    if (!formData.message) {
      tempErrors.message = 'Message is required.';
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const onSubmitEnquiry = async (e) => {
    e.preventDefault();
    if (validate()) {
      await onSubmit(formData);
      setFormData({
        name: '',
        email: '',
        phone: '',
        website: '',
        message: '',
      });
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg" className="enquire-modal">
      <Modal.Header closeButton className="modal-header">
        <Modal.Title>Enquire Now</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Form onSubmit={onSubmitEnquiry}>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Your Name<sup className="text-danger">*</sup></Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={onChangeInput}
                  placeholder="Enter your name"
                />
                {errors.name && <p style={{ color: 'red' }}>{errors.name}</p>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email Address<sup className="text-danger">*</sup></Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={onChangeInput}
                  placeholder="Enter your email"
                />
                {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={onChangeInput}
                  placeholder="Enter your phone number"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="website">
                <Form.Label>Website</Form.Label>
                <Form.Control
                  type="url"
                  name="website"
                  value={formData.website}
                  onChange={onChangeInput}
                  placeholder="Enter your website"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="message">
                <Form.Label>Message<sup className="text-danger">*</sup></Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="message"
                  value={formData.message}
                  onChange={onChangeInput}
                  placeholder="Enter your message"
                />
                {errors.message && <p style={{ color: 'red' }}>{errors.message}</p>}
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" size="lg" className="w-100 rounded-5 mt-4" type="submit">Submit</Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EnquireModal;
